import { FaFileMedical } from "react-icons/fa";
import ServiceRow from "./ServiceRow";
import './LekarskiUverenija.css'
export default function LekarskiUverenija() {
  return (
    <ServiceRow
      id="lekarski"
      icon={<FaFileMedical />}
      title="Лекарски уверенија"
    >
      {/* INTRO */}
   
        <p className="intro-text">
          Лекарско увереније претставува официјален медицински документ со кои се потврдува здравствената и психофизичката способност на лицето.
        </p>
        <p className="intro-text">
          Тие се користат за работа, управување со машини, образование и административни постапки, со клучна улога во превенција и заштита на здравјето.
        </p>
     

      {/* GRID */}
      <div className="lekarski-grid">

        <div className="lekarski-grid-card">
          <h5>💼 За работа</h5>
          <ul className="service-list">
            <li><span className="check">✓</span>Вработување</li>
            <li><span className="check">✓</span> Работа во странство</li>
            <li><span className="check">✓</span>Ризични професии</li>
          </ul>
        </div>

        <div className="lekarski-grid-card">
          <h5>🛂 Администрација</h5>
          <ul className="service-list">
            <li><span className="check">✓</span>Виза</li>
            <li><span className="check">✓</span>Престој</li>
            <li><span className="check">✓</span>Државјанство</li>
          </ul>
        </div>

         <div className="lekarski-grid-card">
          <h5>🎓 Образование</h5>
          <ul className="service-list">
            <li><span className="check">✓</span> Запишување во средно</li>
            <li><span className="check">✓</span>Факултет</li>
          </ul>
        </div>

         <div className="lekarski-grid-card">
          <h4>🧑‍⚕️ Специјализирани</h4>
          <ul className="service-list">
            <li><span className="check">✓</span>Медицинска експертиза</li>
            <li><span className="check">✓</span>Ноќна работа</li>
            <li><span className="check">✓</span>Ризични позиции</li>
          </ul>
        </div>

      </div>

      {/* PROCESS BOX */}
      <div className="mini-card full-width">
        <h4>Како изгледа прегледот</h4>

        <div className="process-steps">
          <div className="step">
            <span>1</span>
            <p>Општ лекарски преглед</p>
          </div>

          <div className="step">
            <span>2</span>
            <p>Лабораториски анализи</p>
          </div>

          <div className="step">
            <span>3</span>
            <p>Психофизичка проценка</p>
          </div>
        </div>
      </div>

      {/* CTA */}
    

    </ServiceRow>
  );
}